fx.ns("desktop.common", class ProductLabel extends fx.components.HBox {
    
	constructor(data, labelFunction)
	{
		super(data);

        this._labelFunction = labelFunction;
	}

    get productTitle()
    {
        let title;
        if (this.data.creation.isBook)
        {
            switch(this.data.creation.cover_option)
            {
                case models.ProductBook.SOFT : title = fx.text("Album Souple"); break;
                case models.ProductBook.HARD :  title = fx.text("Album Rigide"); break;
                case models.ProductBook.BIND :  title = fx.text("Carnet Agrafé"); break;
                case models.ProductBook.SPIRAL :  title = fx.text("Album Spirale"); break;
                case models.ProductBook.LAYFLAT :  title = fx.text("Album Ouverture à plat"); break;
            }
        }
        else if (this.data.creation.isPrint)
        {
            if (this.data.creation.isScrapBooking)
                title = this.data.creation.creationOption.option.title;
            else
            if (this.data.creation.isBox)
                title = this.data.creation.creationOption.option.title + " " + this.data.creation.creationOption.format.dimensions;
            else
                title = fx.text("Tirage Photo") + " " + this.data.creation.creationOption.format.dimensions;
        }
        else if (this.data.creation.isFrame)
        {
            if (this.data.layout)
                title = this.data.layout.lang.title;
            else
                title = fx.text("Cadre Photo");
        }
        else if (this.data.creation.isPoster)
        {
            title = fx.text("Poster Photo");
        }
        else if (this.data.creation.isCalendar)
        {
            title = this.data.creation.finition + " " + this.data.creation.dimensions + ', <span class="price">' + this.data.creation.totalPrice + '</span>';   
        }

        return title;
    }


    create()
    {
        super.create();

        this.productText = new fx.components.Text({className : "product", text : this.productTitle});
        this.addChild(this.productText, {width : "auto", top : 0});

        this.descriptionText = new fx.components.Text({className : "description"});
        this.addChild(this.descriptionText, {width : "auto", top : 0});
    }

    onReady()
    {
        super.onReady();

        this._updateLabel();
    }

     onChildUpdated(action)
    {
        if (action.model instanceof models.CreationElement  && (action.type == "create" || action.type == "delete" || action.impacts("quantity")))
            this.delay(this._updateLabel, 250);
    }

    _updateLabel()
    {
        if (this._labelFunction)
            this.descriptionText.text = this._labelFunction();

        this.descriptionText.toggle(this.descriptionText.text != "" )
    }


});
